import React from "react"

export const VehicleFuelDetailContext = React.createContext(null);

export const useVehicleFuelDetailContext = () => {

const context = React.useContext(VehicleFuelDetailContext);

if (!context) throw new Error("fuel Detail Context not provided!");

return context;
}